import React, { useContext } from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import Image from '@jetshop/ui/Image/Image';
import SiteContentContext from '../SiteContent/SiteContentContext';

const BrandWrapper = styled('div')`
  margin: 0.5rem 0;
  > a {
    display: flex;
    align-items: center;
  }
  .image-wrapper {
    border-radius: 50%;
    width: 50px;
    overflow: hidden;
  }
  .text-wrapper {
    margin-left: 10px;
    font-size: 12px;
  }
`;

export const Designer = ({ category }) => {
  const { designBy } = useContext(SiteContentContext);
  if (!category) return null;
  const hasImage = category?.images?.length > 0;
  return (
    <BrandWrapper>
      <CategoryLink category={category}>
        <div className="image-wrapper">
          {hasImage && (
            <Image
              critical={true}
              aspect={'1:1'}
              crop={true}
              src={category.images[4].url}
              sizes={[100]}
              cover={true}
              quality={80}
            />
          )}
        </div>
        <div className="text-wrapper">
          {designBy} {category.name}
        </div>
      </CategoryLink>
    </BrandWrapper>
  );
};
